import { NgModule } from '@angular/core';
import { InactiveWidgetFooterComponent } from './inactive-widget-footer.component';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';

@NgModule({
  imports: [
    CustomPipesModule
  ],
  declarations: [
    InactiveWidgetFooterComponent
  ],
  exports: [
    InactiveWidgetFooterComponent
  ]
})
export class InactiveWidgetFooterModule {}
